import React from "react";

export default function MySQL_LOWER() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MySQL_LOWER</h1>
      <p>This is the MySQL_LOWER component generated from the SQL JSON.</p>
    </div>
  );
}
